






































































































































































































































































































































declare var window: any;
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { UserProfile } from '../../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import { DocumentPayload } from '../../models/skills/documentpayload';
import { UserAttrSkillWrapper } from '../../models/skills/userattrskillwrapper';
import { DocumentResponse } from '../../models/skills/documentresponse';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import moment from 'moment';
import SelectedPassportList from '@/components/Commons/SelectedPassportList.vue';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';

@Component({
  name: 'PassportDetails',
  components: {
    Datepicker,
    SelectedPassportList,
    ProfilePlaceholder,
    AddEntity,
  },
})
export default class PassportDetails extends Mixins(GuidedSignupUtilities) {
  $moment: any;
  $wlToastr: any;
  private userProfile: UserProfile = new UserProfile();
  private documentPayload: DocumentPayload = new DocumentPayload();
  private editPassports: boolean = false;
  private selectedUserAttrSkillWrapper: UserAttrSkillWrapper = new UserAttrSkillWrapper();
  private replaceUploadedDocument: boolean = false;
  private uploadDocument: boolean = false;
  private selectedDocument: DocumentResponse = new DocumentResponse();
  private editMode: boolean = false;
  private supportedFileSize = 0;
  private isDropBoxFileUploaded: boolean = false;
  private dropBoxFile?: string;
  private dropBoxFileName?: string;
  private selectedPassport: any = {
    userIdentificationId: 0,
    userIdentificationName: '',
    userIdentificationNumber: '',
    effectiveDate: '',
    expiryDate: '',
  };
  private passportFile: any = null;
  private passportFileExpiryDate: any = null;
  private passportFileEffectiveDate: any = null;
  private passportFileNumber: any = null;
  private passportFileNotExpire: any = null;
  private searchText: string = '';

  @Prop({ default: () => new Vue(), type: Vue }) bus;

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get passportUploadEnabled() {
    return false;
  }

  /****************************** */
  get isGuidedSignupPage() {
    var str = this.$route.path!;
    console.log('str is ', str);
    console.log('returning ', str.includes('guidedsignup'));
    return str.includes('guidedsignup');
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  get passportList() {
    if (!this.searchText.trim()) {
      return vxm.passport.CountryList;
    }
    return vxm.passport.CountryList.filter((country: any) => {
      return country.name.toLowerCase().includes(this.searchText.toLowerCase());
    });
  }

  get savedPassportList() {
    return vxm.passport.SavedPassportList.map((list) => {
      const country = vxm.passport.CountryList.find(
        (item) => item.countryId === list.identificationMasterId,
      );
      return {
        ...list,
        userIdentificationName: country.userIdentificationName,
        document: list.document || {},
      };
    });
  }

  async saveSelectedPassport(id) {
    const isSelectedAlready = vxm.passport.SavedPassportList.find(
      (list) => list.identificationMasterId === id,
    );
    if (isSelectedAlready) {
      this.$wlToastr(
        'error',
        this.$t('passport.country.selected.already'),
        this.$t('profile-accordion.passport'),
      );
      return;
    }
    const response = await vxm.passport.saveSelectedPassport({
      identificationMasterId: id,
      isPartofRegistration: false,
    });
    if (response.meta.success) {
      this.$wlToastr(
        'success',
        this.$t('passport.country.selected.success'),
        this.$t('profile-accordion.passport'),
      );
    }
  }

  openPassportUploadModal(passport) {
    this.selectedPassport = passport;
    this.uploadDocument = true;
    this.editMode = false;
    this.passportFileNotExpire = false;
    this.passportFileExpiryDate = null;
    this.passportFileEffectiveDate = null;
    this.passportFileNumber = null;
  }

  validatePassportUpload() {
    if (!this.isDropBoxFileUploaded && this.passportUploadEnabled) {
      if (!this.editMode) {
        if (!this.passportFile) {
          this.$wlToastr('error', this.$t('select-file-err-msg'), this.$t('profile-accordion.passport'));
          return false;
        }
      }

      if (
        this.passportFile &&
        this.passportFile.size > this.supportedFileSize
      ) {
        this.$wlToastr(
          'error',
          this.$t('License_FileSizeRestriction', {
            maxSize: this.supportedFileSize / (1024 * 1024),
          }),
          this.$t('profile-accordion.passport'),
        );
        return false;
      }

      // if (this.passportFile && !this.skillDocTypeMatches()) {
      //   this.$wlToastr(
      //     'error',
      //     'File type Not supported. Upload ' +
      //       vxm.configs.getGlobalConfigValue('ALLOWED_RESUME_FORMATS'),
      //     'Passport',
      //   );
      //   return false;
      // }
    }
    if (
      this.passportUploadEnabled &&
      this.passportFileNotExpire &&
      !this.passportFileEffectiveDate
    ) {
      this.$wlToastr(
        'error',
        this.$t('License_EnterEffectiveDate'),
        this.$t('profile-accordion.passport'),
      );
      return false;
    }

    if (
      this.passportFileEffectiveDate &&
      !this.passportFileNotExpire &&
      !this.passportFileExpiryDate
    ) {
      this.$wlToastr('error', this.$t('License_EnterExpiryDate'), this.$t('profile-accordion.passport'));
      return false;
    }

    if (
      !this.passportFileNotExpire &&
      this.passportFileEffectiveDate &&
      this.passportFileExpiryDate &&
      this.passportFileEffectiveDate >= this.passportFileExpiryDate
    ) {
      this.$wlToastr('error', this.$t('document-expire-err-msg'), this.$t('profile-accordion.passport'));
      return false;
    }
    return true;
  }

  async editSelectedPassportFile() {
    if (!this.validatePassportUpload()) {
      return;
    }
    const formData = new FormData();
    const documentInfo = {
      identificationMasterId: this.selectedPassport.identificationMasterId,
      userIdentificationId: this.selectedPassport.userIdentificationId,
      userIdentificationName: this.selectedPassport.userIdentificationName,
      userIdentificationNumber: this.passportFileNumber,
      effectiveDate:
        this.passportFileEffectiveDate &&
        vxm.utility.convertLocalTimeToUTC(this.passportFileEffectiveDate),
      expiryDate:
        this.passportFileExpiryDate &&
        vxm.utility.convertLocalTimeToUTC(this.passportFileExpiryDate),
      document: { ...this.selectedPassport.document },
    };
    if (this.passportFile) {
      let array = this.passportFile.name.split('.');
      let extension = array[array.length - 1];
      formData.append('document', this.passportFile);
      documentInfo.document.docExtType = extension;
      documentInfo.document.docNameWithExtension = this.passportFile.name;
    }
    if (this.passportFileNotExpire) {
      delete documentInfo.expiryDate;
    }
    formData.append('documentInfo', JSON.stringify(documentInfo));
    const response = await vxm.passport.saveSelectedPassportFile(formData);
    if (response.meta.success) {
      this.$wlToastr(
        'success',
        this.$t('passport.document.update.success'),
        this.$t('profile-accordion.passport'),
      );
    }
    this.uploadDocument = false;
  }

  async saveSelectedPassportFile() {
    if (!this.validatePassportUpload()) {
      return;
    }
    let document = {
      docExtType: '',
      docNameWithExtension: '',
    };
    if (this.passportFile) {
      let array = this.passportFile.name.split('.');
      let extension = array[array.length - 1];
      document = {
        docExtType: extension,
        docNameWithExtension: this.passportFile.name,
      };
    }
    const formData = new FormData();
    const documentInfo = {
      identificationMasterId: this.selectedPassport.identificationMasterId,
      userIdentificationId: this.selectedPassport.userIdentificationId,
      userIdentificationName: this.selectedPassport.userIdentificationName,
      userIdentificationNumber: this.passportFileNumber,
      effectiveDate:
        this.passportFileEffectiveDate &&
        vxm.utility.convertLocalTimeToUTC(this.passportFileEffectiveDate),
      expiryDate:
        this.passportFileExpiryDate &&
        vxm.utility.convertLocalTimeToUTC(this.passportFileExpiryDate),
      document: document,
    };
    if (this.passportFileNotExpire) {
      delete documentInfo.expiryDate;
    }
    formData.append('documentInfo', JSON.stringify(documentInfo));
    formData.append('document', this.passportFile);
    const response = await vxm.passport.saveSelectedPassportFile(formData);
    if (response.meta.success) {
      this.$wlToastr(
        'success',
        this.$t('passport.document.upload.success'),
        this.$t('profile-accordion.passport'),
      );
    }
    this.uploadDocument = false;
  }

  editPassportDocument(passport) {
    this.selectedPassport = passport;
    this.uploadDocument = true;
    this.editMode = true;
    this.passportFileEffectiveDate = passport.effectiveDate
      ? new Date(passport.effectiveDate)
      : '';
    this.passportFileExpiryDate = passport.expiryDate
      ? new Date(passport.expiryDate)
      : '';
    this.passportFileNumber = passport.userIdentificationNumber;
    this.passportFile = null;
    this.replaceUploadedDocument = false;
    this.passportFileNotExpire = passport.effectiveDate && !passport.expiryDate;
  }

  async mounted() {
    this.bus.$on('on-next-step', this.onNextStep);
    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
    await vxm.passport.fetchCountryList();
    await vxm.passport.fetchSavedPassportList();
  }

  onNextStep() {
    this.$emit('go-to-next');
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  addPassports() {
    this.editPassports = true;
  }

  ////////////**************************** */

  isAttrbiuteUploadedforuserAttrSkillWrapper(
    val: UserAttrSkillWrapper,
  ): boolean {
    if (val == null) return false;
    const selectedWrapper = this.userProfile.userAttributeSkills.filter(
      (doc) => {
        return (
          doc.userAttribute.userAttributeID == val.userAttribute.userAttributeID
        );
      },
    )[0];
    if (
      selectedWrapper === undefined ||
      selectedWrapper.documentResponse === undefined
    ) {
      return false;
    } else {
      if (selectedWrapper.documentResponse !== null) return true;
      else return false;
    }
  }

  public transformDate(dttm: number): string {
    if (dttm === null) return '';
    const locale = vxm.users.getUserLang || 'en';
    return moment(dttm).locale(locale).format(this.getCompanyDateFormat.toUpperCase());
  }

  async selectFromDropbox(userAttributeID: number, documentId: number) {
    console.log('documentid :' + documentId);
    const vm = this;
    vm.documentPayload.uid = userAttributeID;
    vm.documentPayload.documentId = documentId;
    vxm.skills
      .uploadDropboxAttributeFile(vm.documentPayload)
      .then(async (status: string) => {
        console.log('STATUS: select from Dropbox ', status);
        if (!!status) {
          this.isDropBoxFileUploaded = true;
          this.dropBoxFile = status;
          this.dropBoxFileName = decodeURI(this.dropBoxFile);
          this.dropBoxFileName = this.dropBoxFileName.split('\\').pop();
          this.dropBoxFileName =
            this.dropBoxFileName && this.dropBoxFileName.length > 0
              ? this.dropBoxFileName.split('/').pop()
              : this.dropBoxFileName;
        } else {
          this.isDropBoxFileUploaded = false;
        }
      })
      .catch((err) => {
        vm.$wlToastr('error', vm.$t('document-upload-err-msg'), vm.$t('SkillsDetails_DocumentUpload'));
      });
    // this.uploadDocument = false;
    // this.selectedDocument = new DocumentResponse();
  }

  async selectFromDropbox_original(
    userAttributeID: number,
    documentId: number,
  ) {
    console.log('documentid :' + documentId);
    const vm = this;
    vm.documentPayload.uid = userAttributeID;
    vm.documentPayload.documentId = documentId;
    vxm.skills
      .uploadDropboxAttribute(vm.documentPayload)
      .then(async (status) => {
        console.log('STATUS:', status);
        if (status === 'success') {
          vm.$wlToastr('success', vm.$t('SkillsDetails_SuccessfullyUploaded'), vm.$t('skill.success.message.title'));
          vxm.users.getProfileStrength();
          vxm.users.getUserProfileAndNavigateTo('Skills');
        } else {
          vm.$wlToastr('info', vm.$t('SkillsDetails_CancelUpload'), vm.$t('skill.success.message.title'));
        }
      })
      .catch((err) => {
        vm.$wlToastr(
          'error',
          vm.$t('ResumeDetails_UploadResumeError'),
          vm.$t('ResumeDetails_UploadResume'),
        );
      });
  }

  async downloadResume(fileGUID, name) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + fileGUID;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download resume');
      }

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = name || 'Passport';

      // Trigger a click event to initiate the download
      link.click();

      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }

  replaceUploadedDoc() {
    this.replaceUploadedDocument = !this.replaceUploadedDocument;
  }

  cancelSaveSkillMain() {
    this.replaceUploadedDocument = false;
    this.uploadDocument = false;
    this.isDropBoxFileUploaded = false;
    this.dropBoxFile = '';
    this.dropBoxFileName = '';
  }

  isDateInPast(dttm: number): boolean {
    if (dttm === null) return false;
    var result = new Date(dttm);
    result.setDate(result.getDate() + 1);
    dttm = result.getTime();
    var expDate = new Date(dttm);

    var now = new Date();
    if (now > expDate) return true;
    else return false;
  }

  skillDocTypeMatches(): boolean {
    const ext = this.passportFile.name.match(/\.([^\.]+)$/)[1];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    return allowedResumeFormat.includes(ext.toLowerCase());
  }
}
